import { AppState, Auth0Provider } from "@auth0/auth0-react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material/styles";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { withLDProvider } from "launchdarkly-react-client-sdk";
import { Provider } from "react-redux";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import App from "./App/App";
import { ErrorBoundary } from "./App/Components/ErrorBoundary/ErrorBoundary";
import ManageSubscription from "./App/Components/ManageSubscription/ManageSubscription";
import { QueryProvider } from "./App/Queries/QueryProvider";
import { store } from "./App/State/Store";
import theme from "./App/Styles/theme";
import { initAxeTesting } from "./axeTesting";
import "./index.css";
import { createRoot } from "react-dom/client";

if (import.meta.env.VITE_NODE_ENV === "development" && !window.parent.Cypress) {
  initAxeTesting();
}

function AuthApp() {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo ?? "/", { replace: true });
  };

  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENTID}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: import.meta.env.VITE_AUTH0_AUDIENCE,
      }}
      cacheLocation={window.parent.Cypress || import.meta.env.DEV ? "localstorage" : "memory"}
      onRedirectCallback={onRedirectCallback}
    >
      <Provider store={store}>
        <QueryProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
          </LocalizationProvider>
        </QueryProvider>
      </Provider>
    </Auth0Provider>
  );
}
function StyledApp() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <BrowserRouter>
            <Routes>
              <Route path="*" element={<AuthApp />} />
              <Route path="/managesubscription/:messageId" element={<ManageSubscription />} />
            </Routes>
          </BrowserRouter>
        </ErrorBoundary>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

const FeatureToggleProvider = withLDProvider({
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_CLIENTID,
  options: {
    streaming: true,
  },
})(StyledApp);

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(<FeatureToggleProvider />);
